var _rect, _rect2, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 29.8325,
    height: 20.4566,
    rx: 2,
    fill: "#F0FAEA",
    stroke: "#9EA1AA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16797,
    y: 15.1152,
    width: 29.8325,
    height: 20.4566,
    rx: 2,
    fill: "#85D759",
    stroke: "#696F86"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.16797,
    y1: 22.7129,
    x2: 39.0005,
    y2: 22.7129,
    stroke: "#696F86"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.2246,
    y1: 31.2363,
    x2: 16.3388,
    y2: 31.2363,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.6172,
    y1: 31.2363,
    x2: 22.7313,
    y2: 31.2363,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.1b058deac8df173a64af6a45efa82472.svg";
export { ForwardRef as ReactComponent };